import { createActionCreators } from 'store/utils/actionHelpers'
import types from './types'
import CmsApis from 'apis/cmsApis'

const {
  fetchElementsRequest,
  fetchElementsSuccess,
  fetchElementsFailure,
} = createActionCreators(types)

export const fetchElements = () => (dispatch) => {
  dispatch(fetchElementsRequest())
  return CmsApis.getElements()
    .then(({ data }) => {
      // set storeId to CmsApi class
      // so that next time we call an api, storeId will be attached to headers
      return dispatch(fetchElementsSuccess(data))
    })
    .catch((error) => dispatch(fetchElementsFailure({ error })))
}



// WEBPACK FOOTER //
// ./src/store/elements/actions.js